import { render } from "./RecentCalls.vue?vue&type=template&id=21de2c96&scoped=true&ts=true"
import script from "./RecentCalls.vue?vue&type=script&lang=ts"
export * from "./RecentCalls.vue?vue&type=script&lang=ts"

import "./RecentCalls.vue?vue&type=style&index=0&id=21de2c96&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21de2c96"]])

export default __exports__